module.exports = __webpack_public_path__ + "static/img/FireBallJurassic-zh.7a5d48bc.png";